<template>
 <page>
   <head-nav title="language.add_news_item">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

  <scroll-page>
    <page-padding>
     
      
      <ui-input title="language.title" type="text" v-bind:val="title" @input="(v)=>{title = v}">
        <div slot="after"> <ui-icon @click.native="toggleSticky" icon="thumbtack" backgroundColor="transparent" :color="computeStickyColor" class="thumbtack"/></div>
      </ui-input>
       
      

      <!--<ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{bb_description = v}"></ui-textarea>-->
      <ui-htmlarea title="language.provide_description" v-bind:val="description" @input="(v)=>{bb_description = v}"></ui-htmlarea>
      <ui-input title="language.provide_youtube_url" type="text" v-bind:val="youtube_url" @input="(v)=>{youtube_url = v}"></ui-input>
      
      <!-- pick images on mobile -->
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="getCameraImage()" title="language.camera" ></button-action>
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="getGalleryImages()" title="language.gallery" ></button-action>
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="chooseMobileFile()" title="language.choose_mobile_file" ></button-action>


      <!-- pick images desktop variant -->
      <button-file v-if="!isMobile" :active="computeUploadImagesLeft>0" :multiple="true" accept="image/jpeg,image/png,application/pdf" title="language.choose_file" @change="getGalleryImagesBrowser"></button-file>
      
</page-padding>
      <upload-gallery :medias="medias"/>
<page-padding>
      
      
        <!--<ui-check v-if="group_id==0" :val="check.app" v-on:selected="checkPlaceInSchoolApp" title="language.place_in_schoolapp" />-->
        <ui-check v-if="computeOudersFeedCheck" :val="check.feed_ouders" v-on:selected="val=>{check.feed_ouders = val}" title="language.place_in_feed_ouders" />
        <ui-check :val="check.feed_groep" v-on:selected="val=>{check.feed_groep = val}" title="language.place_in_feed_groep" />
        <ui-check :val="check.website" v-on:selected="val=>{check.website = val}" title="language.place_on_website" />
        <ui-check :val="check.narrowcasting" v-on:selected="val=>{check.narrowcasting = val}" title="language.place_on_narrow" />
        <ui-check :val="check.allow_reactions" v-on:selected="val=>{check.allow_reactions = val}" title="language.allow_reactions" />
        
        <ui-check v-if="computePushCheck" :val="check.pushnote" v-on:selected="val=>{check.pushnote = val}" title="language.important_pushnote" />
    
        <divider title=""/>
        
        <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
    
     </page-padding>
  </scroll-page> 
   </page>
</template>

<script>
/* present images in a scroll menu */


import { mapState } from 'vuex';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiCheck from '../components/UiCheck.vue'
import UiInput from '../components/UiInput.vue';
import UiHtmlarea from '../components/UiHtmlarea.vue';
//import UiTextarea from '../components/UiTextarea.vue';
import UploadGallery from '../components/uploadGallery/UploadGallery.vue';
import { imagePicker } from '../services/ImagePicker.js'
import { api } from '../services/Api';
import Page from '../pages/Page.vue';
import { modalService } from '../services/ModalService';
import i18n from "../language.js";
import { fileTransfer } from '../services/FileTransfer.js';
import { eventBus } from '../services/EventBus.js';
import Vue from 'vue';
import ScrollPage from '../components/ScrollPage.vue';
import Divider from '../components/dividers/Divider.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';
import { history } from "../services/History.js";
import UiIcon from '../components/UiIcon.vue';
import ButtonFile from '../components/buttons/ButtonFile.vue';
import { cordovaInit } from '../services/CordovaInit.js';
import { FILE_SIZE } from '../settings/FILE_SIZE';
import { statusBar } from '../services/StatusBar.js';

export default {
  name: 'add-news-item-page',
  data:function(){
    return{
      group_id:this.$route.params.id, // only used for send_pushnote
      news_id:this.$route.params.news_id,
      title:"",
      description:"",
      bb_description:"",
      youtube_url:"",
      buttonActive:true,
      maxImages:15,
      medias:[],
      mediaKey:0,
      group:{ name:"no-name" },
      check:{
        //app:true,
        feed_ouders:true,
        feed_groep:true,
        website:false,
        narrowcasting:false,
        pushnote:false,
        allow_reactions:false,
        sticky:false,
      },
      isMobile:cordovaInit.isMobile(),
    }
  },

  computed:{
    ...mapState([
       'groups','appSettings','user_schools'
       ]),
      upload_path:function(){
        var school=this.user_schools.find(school => school.active === 1);
        return api.getUrl(school,"add_news_item_photo.php");
      },
      computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.add_news_item');
        }
      },
      computeOudersFeedCheck(){
        if(this.appSettings.user_level==USER_LEVEL.STUDENT){
          return false;
        }
       
        return true;
      },
      computePushCheck(){
        if(this.appSettings.user_level==USER_LEVEL.STUDENT){
          return false;
        }
        if(this.appSettings.user_level==USER_LEVEL.ADMIN){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.TEACHER){
          return true;
        }
        if(this.appSettings.user_level==USER_LEVEL.PARENT){
          return false;
        }
        return false;
      },
      computeUploadImagesLeft(){
        
        var imagesLeft=this.maxImages-this.medias.length;
        if(imagesLeft<0){ imagesLeft=0;}
        return imagesLeft;
      },
      computeStickyColor(){
        if(this.check.sticky){
          return '#8CC63E';
        }
        return '#707070';
      }
  },
  components: {
    ButtonActivate,
    ButtonAction,
    ButtonFile,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiHtmlarea,
    UiCheck,
    UploadGallery,
    Page,
    ScrollPage,
    Divider,
    UiIcon,
  },

  methods:{
    back(){
      this.$router.push(history.get());
    },
    countFiletypes(){
      var typeCount={};

      this.medias.map(item =>{
        var extension=item.fileName.split(".").slice(-1).pop();
        // get extension count from types
        typeCount[extension] ? typeCount[extension]++ : typeCount[extension]=1;
      });
      return typeCount;
    },
    checkPlaceInSchoolApp(val){
      this.check.app = val;
      if(!val){
        // also switch ooof send push
        this.check.pushnote=false;
      }
    },
    isFormComplete(){

      if(this.title===""){
          modalService.createAlert(i18n.t('language.form_incomplete_title'))
        return false;
      }

      return true
    },
    getCameraImage(){

      var args={
          allowEdit : false,
          targetWidth: 1920,
          targetHeight: 1920,
          quality: 70,
          mediaType: window.Camera ? window.Camera.MediaType.PICTURE : undefined,
          correctOrientation:true,
        };
        
      imagePicker.getCamera(args).then(media=>{
        
          this.medias.push(media);
          //this.mediaKey=new Date().getTime();
      })

    },
    /* get browser files */
    getGalleryImagesBrowser(e){
      
      this.buttonActive=false;

      imagePicker.fileListToMedias(e.target.files).then(result=>{
        
        var c=0;
        result.forEach(media=>{
          setTimeout(()=>{
            this.medias.push(media)
          },c*50);
          c++;
           
        })

        
        this.buttonActive=true;
      })

    },
    /* images on mobile */
    getGalleryImages(){

      this.buttonActive=false;
      
       var args = {
        'selectMode': imagePicker.mediaType.IMAGE, //101=picker image and video , 100=image , 102=video
        'maxSelectCount': this.computeUploadImagesLeft, //default 40 (Optional)
        'maxSelectSize': FILE_SIZE.IMAGE, //180000000=180M (Optional) only android (15000000 15 mb)
      };
      
     

      imagePicker.getMedias(args).then( medias => {
        this.buttonActive=true;
       
        var c=0;
        medias.forEach(media=>{
         
          setTimeout(()=>{
            this.medias.push(media)
          },c*50);
          c++;
           
        })
        
      })

      
    },
    /* choose file on mobile, only for files no images */
    /* only one file per time */
    chooseMobileFile(){
      //var types="application/pdf,audio/mpeg";
      var types="application/pdf";
      window.chooser.getFile(types).then(result=>{
          this.file=result;


          var fileSize=this.file.data.byteLength;
          
          if(fileSize> FILE_SIZE.FILE && FILE_SIZE.FILE>0){
            var txt=this.$t("language.file_limit_is")+" "+FILE_SIZE.FILE/1000000+"mb"
            modalService.createAlert(txt)
            return;
          }


         // check if filename has extension, if not
         // then give it an extension
         var extension=this.file.name.split(".")[1];

        

         var thumb;
         switch(this.file.mediaType){
          case "audio/mpeg":
            thumb=require('../assets/audio_bg.png');
            extension ? false : this.file.name+=".mp3";
          break;
          case "application/pdf":
            thumb=require('../assets/pdf_bg.png');
            extension ? false : this.file.name+=".pdf";
          break;
          default:
            modalService.createAlert("pick mp3 or pdf filetype");
            return;
          
         }

          // this.file.data is the uint8array data...
          var media={
            fileName:this.file.name,
            url:this.file.dataURI, //dataURI is base 64 data
            thumbnail:thumb,
            exifOrientation:0,
          }
          
          // allows the picker to close i guess..
          // otherwise we have rendering issues corrupting the view
          setTimeout(()=>{
            this.medias.push(media);
            statusBar.resetViewBugMessingThingsUp();
          },500)
          

        })
    },
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

      this.buttonActive=false;

      this.createNewsItem();
    
    },
    createNewsItem(){
      // first create album
      
      var payload={
          news_id:this.news_id,
          title:this.title,
          youtube_url:this.youtube_url,
          content:this.bb_description,
          website:this.check.website ? 1 : 0,
          narrowcasting:this.check.narrowcasting ? 1 : 0,
          allow_reactions:this.check.allow_reactions ? 1 : 0,
          pushnote:this.check.pushnote ? 1 : 0,
          feed_ouders:this.check.feed_ouders ? 1 : 0,
          feed_groep:this.check.feed_groep ? 1 : 0,
          sticky:this.check.sticky ? 1 : 0,
      }



      this.$store.dispatch('add_news_item',payload).then(result=>{
       
        var news_id=result.data.id;
        if(!news_id){
          Vue.$toaster.toast("[error: ] no id returned from add_news_item");
          return;
        }
        
        // start uploading medias first item
        this.uploadNextFile(news_id,0);
      });
      
      

    },
    allUploadFinished(news_id){
        

      Vue.$toaster.toast("language.news_item_add_success");
       
      // send push
      this.sendPushNote(news_id);
       
      // rreset form vars etc
      this.buttonActive=true;
      this.medias=[];
      this.title=""
      this.description="";
      this.youtube_url="";
        
      this.back();
    },
    sendPushNote(news_id){
      
      // if not sending to parents or students..
      if (!this.check.feed_ouders && !this.check.feed_groep)
      {
        // dont send push
        return;
      }
      

      var group_name=this.group ? this.group.name : this.$t('language.groeps_overstijgend');

      var payload={
        group_id:this.group_id,
        title:this.$t('language.pushnote_news_item_created'),
        message:group_name+": "+this.title,
        url:"/news_item/"+news_id,
        type:"news",
        important:this.check.pushnote ? 1 : 0,
      }
      
      
      //console.log("******** SEND PUSH NOTE ***********");
      //console.dir(payload)

      this.$store.dispatch('send_pushnote',payload);
      
    },
    uploadNextFile(news_id,index){
     
      if(index>=this.medias.length){
        this.allUploadFinished(news_id)
        return;
      }
      var media=this.medias[index];
      
      var fileName=media.fileName || "mediafile-has-no-name";
      
     // console.log("ul next:",media,index)
      var params={
        //group_id:this.group ? this.group.id : 0,
        file_name:fileName, /* filename has no extension if from google drive?*/
        id:news_id,
        exif_orientation:media.exifOrientation.toString(),
        //sort:index,
        token:this.appSettings.token,
      }
      
      var payload={media}
      eventBus.$emit("MEDIA_UPLOAD_START",payload);
      
     //console.log("aaaaaa")
     //console.log(media.url);

     fileTransfer.uploadFile(media.url,this.upload_path,params).then(()=>{

        
        var payload={media}
        // start animate out gallery image
        eventBus.$emit("MEDIA_UPLOAD_DONE",payload);
        index+=1;

        setTimeout(()=>{
          // allow some time for animaion to finish
          this.uploadNextFile(news_id,index);
        },350)
        
        
        
      },error=>{
        alert("filetransfer error in add news item: "+error)
        this.buttonActive=true;
      })
      
    },
    toggleSticky(){
      
      this.check.sticky=!this.check.sticky;
    },
    addListeners(){
      eventBus.$on('UPLOAD_GALLERY_LOADING_DONE',()=>{
        this.buttonActive=true;
      })
    },
    removeListeners(){
      eventBus.$off('UPLOAD_GALLERY_LOADING_DONE');
    }

  },
  beforeDestroy(){
    this.removeListeners();
  },
  mounted(){

    // get group by id
    this.group = this.groups.find(group => group.id === this.group_id);


    this.addListeners();

    // if userlevel student then standard switch off ouders checkbox
    if(this.appSettings.user_level==USER_LEVEL.STUDENT){
      this.check.feed_ouders=false;
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnail{
  width:100%;
  height:auto;
}
.thumbtack{
  font-size:1.5em;
  cursor:pointer;
}
</style>